import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AddTicketPage } from './add-ticket.page';

const routes: Routes = [
  {
    path: '',
    component: AddTicketPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AddTicketPageRoutingModule {}
